import type { FaireProductEntity } from "../../entity_types/product";

export const p_b5w3vswhz2: FaireProductEntity = {
  token: "p_b5w3vswhz2",
  type: "product",
  name: "Ocean Bomb Tropical Fruit Flavor Majin Buu 6ct (330ml) (Taiwan)",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/d10e454b53e79df3e21b928129d4430c6b3703cf3dfb56b334364d1b1c9589b7.jpeg",
  galleryImageUrls: [],
  priceDollars: 21,
  description:
    "Collectible Majin Buu Can — Retail-Friendly 6ct 🍍💗\n\nBring anime cooler heat to your shelves with Ocean Bomb Tropical Fruit Flavor Majin Buu (330ml) (Taiwan) — 6ct. The collectible Dragon Ball can art drives impulse buys, and the bright tropical fruit flavor makes it an easy repeat purchase.\n\nWhat You’re Getting ✅\n\n * \nCase Pack: 6ct\n\n * \nSize: 330ml each\n\n * \nFlavor: Tropical Fruit 🍍🥭\n\n * \nCountry: Taiwan\n\n * \nType: Carbonated soft drink / collectible can\n\n * \nCharacter: Majin Buu (Dragon Ball)\n\nWhy It Sells 🛒\n\n * \nDragon Ball branding + collectible cans = strong demand\n\n * \nTropical fruit flavor is refreshing and widely liked\n\n * \n6ct case is perfect for resale and quick cooler restocks\n\n * \nGreat for anime sections, endcaps, and bundle builds\n\nKey Features ✅\n\n * \nOcean Bomb x Dragon Ball collectible drink cans\n\n * \nRefreshing tropical fruit flavor 🍍🥭\n\n * \n6-count case for easy stocking and resale\n\n * \nPerfect for convenience stores, snack shops, smoke shops, and gift stores\n\n * \nGreat add-on item for anime bundles and international drink flights\n\n * \nBest served ice cold\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:23.297Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
